export default __webpack_public_path__ + "static/media/Nunito-BoldItalic.bf268a33.ttf";